const ReturnTypes = Object.freeze({
  CUSTOM_URL: 0,
  PAGE: 1
})

export { ReturnTypes }



// WEBPACK FOOTER //
// ./src/modules/sites/enum/ReturnTypesEnum.js